import {Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useParams, useRouteMatch} from 'react-router-dom';
import GenericHeader from '../../../../../../../../components/generic-header/generic-header';
import {useOffice} from '../../../../../../../../contexts/office/context';
import {ScreenPaths} from '../../../../../../../../enums';
import {translations} from '../../../../../../../../i18n/translations';
import {SeniorAttachmentsAddButton} from './senior-attachments-add-button';

type SeniorAttachmentsHeaderProps = {
  onCreateAttachmentClick: () => void;
  canWrite?: boolean;
};

export function SeniorAttachmentsHeader(props: SeniorAttachmentsHeaderProps) {
  const {id, entityId}: {id?: string; entityId?: string} = useParams();
  const {url} = useRouteMatch();
  const officeContext = useOffice();
  const {t} = useTranslation();

  const seniorName =
    officeContext.state.userForm?.user.displayName || officeContext.state.userForm?.user.name;

  return (
    <GenericHeader
      titleCrumbs={[
        {
          label: t(translations.screen_paths.professional_caregiver_seniors),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
        },
        {
          label: seniorName,
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
        },
        {
          label: t(translations.screen_paths.senior_personal_data),
          link: url,
        },
        {
          label: t(translations.screen_paths.senior_attachments),
          link: url,
        },
      ]}
      isLoading={false}
      leftColumn={<></>}
      rightColumn={
        <Stack direction="row" justifyContent="flex-end" alignItems="center" gap="10px">
          <SeniorAttachmentsAddButton
            onClick={props.onCreateAttachmentClick}
            disabled={!props.canWrite}
          />
        </Stack>
      }
    />
  );
}
